import { createFileRoute, notFound } from "@tanstack/react-router";
import { CatalogCategoryPage } from "@/components/sections/catalog-pages";
import { getCatalogCategory } from "@/lib/services-catalog";
import { TopRelatedDigitalItems } from "@/components/sections/top-related-digital-items";

export const Route = createFileRoute("/services/pos-software/")({
  component: PosSoftwareIndex,
  head: () => ({
    meta: [
      { title: "POS Software — CoderLity" },
      { name: "description", content: "Retail and restaurant point-of-sale systems with fast checkout, real-time inventory, kitchen displays and online orders." },
      { property: "og:title", content: "POS Software — CoderLity" },
      { property: "og:description", content: "Retail & restaurant POS built for speed, accuracy and multi-branch scale." },
      { property: "og:url", content: "/services/pos-software" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/services/pos-software" }],
  }),
});

function PosSoftwareIndex() {
  const cat = getCatalogCategory("pos-software");
  if (!cat) throw notFound();
  return (
    <>
      <CatalogCategoryPage cat={cat} />
      <TopRelatedDigitalItems hub="pos" />
    </>
  );
}

